import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import * as OnboardingService from "Services/Apis/Onboarding";

import Dropdown from 'components/Atoms/Dropdown/Dropdown';
import Icon from 'components/Atoms/Icons/Icon';
import { LuUser2 as User2, LuChevronDown, LuChevronUp} from 'react-icons/lu';

import { GreetingsUser } from 'structure/header/GreetingsUser';
import { convertItemsMenu } from 'Utils/convertItemsMenu';

import { onboardingUrl } from 'Constants/Onboarding';

import PropTypes from 'prop-types';
import { hasEncryptedSSO } from 'Constants/Auth';

const MenuUser = (props) => {
    const { userName, items } = props;

    const [dropdownItems, setDropdownItems] = useState([]);
    const { user } = useSelector((state) => state.oidc);

    const redirectToOnboarding = () => {
        const campaignId = process.env.REACT_APP_TENANT_ID;
      
        if (!hasEncryptedSSO) {
          location.href = onboardingUrl + campaignId;
      
          return;
        }
        OnboardingService.encrypt(user)
          .then(({ data: encryption }) => window.location.href = `${onboardingUrl}?sso=${encryption.data}`)
          .catch(err => console.error(err));
    }

    useEffect(() => {
        if (!items) return;
        const convertedItems = convertItemsMenu(items);
        const updatedDropdownItems = convertedItems.map(item => {
            if (item.type === '2FA') {
                return { ...item, label: (<a href='#' onClick={redirectToOnboarding}>{item.label}</a>) };
            }
            return item;
        })
        setDropdownItems([...updatedDropdownItems]);
    }, [items]);

    return (
        <div className="header-user">
            {
                <Dropdown
                title={GreetingsUser(userName)}
                iconOpen={<Icon className="lucide color-neutral-dark txt-profile-arrow-icon" size="18px" component={LuChevronDown} />}
                iconClose={<Icon className="lucide color-neutral-dark txt-profile-arrow-icon" size="18px" component={LuChevronUp} />}
                template="marketplace"
                items={dropdownItems}
                icon={<Icon className="lucide" size={`18px`} component={User2} />}
                />
            }
        </div>
    );
};

MenuUser.propTypes = {
    userName: PropTypes.string,
    isLoading: PropTypes.bool,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            title: PropTypes.string,
            icon: PropTypes.string,
            type: PropTypes.string,
            path: PropTypes.string,
        })
    ),
}
export default MenuUser;
